import axios from 'axios';

export class RequestAlliance {
  static subscribe90English = async (name, email, cardToken) => {
    await axios.post(`alliance/subscribe/90-english`, {
      name: name,
      email: email,
      card_token: cardToken,
    });
  };

  static subscribeGlobeEnglishSchool = async (name, email, cardToken) => {
    await axios.post(`alliance/subscribe/globe-english-school`, {
      name: name,
      email: email,
      card_token: cardToken,
    });
  };
}
